module.exports = __webpack_public_path__ + "img/lr-cb66-y1.a5e9fe7e.gif";